<template>
  <div>
    <!-- <YA_ScrollComponent :scrollHeight="55"> -->
      <PowerGrammarFixMain ref="mainHeight" />

      <div>
        <PowerGrammarFixContent />
      </div>

      <v-footer inset padless>
        <YA_footer />
      </v-footer>
    <!-- </YA_ScrollComponent> -->
  </div>
</template>

<script>
import YA_footer from '@/components/WebBar/YA_footer.vue';
import YA_ScrollComponent from '@/components/WebBar/YA_ScrollComponent.vue';
import PowerGrammarFixMain from '@/components/PowerGrammarFix/PowerGrammarFixMain.vue';
import PowerGrammarFixContent from '@/components/PowerGrammarFix/PowerGrammarFixContent.vue';

export default {
  
  name: 'PowerGrammarFixView',
  components: {
    YA_footer,
    // YA_ScrollComponent,
    PowerGrammarFixMain,
    PowerGrammarFixContent,
  },
  data() {
    return {

    }
  },
  created() {
    this.$store.watch(
      (state) => state.powerGrammarFixMsg.powerGrammarFixMainHeight, () => {
        if (this.$store.getters.getpowerGrammarFixMainHeight) {
          window.scrollTo({
            top: this.$refs.mainHeight.$el.clientHeight,
            behavior: 'smooth',
          });
          this.$store.commit('HandlepowerGrammarFixMainHeight', false);
        }
      }, {
        deep: true
      }
    );
  },
  mounted() {

  },

  methods: {

  }

};
</script>

<style scoped>
</style>